// @ts-check
import 'Styles/alert.scss';
import Helper from 'Utils/Helper';
import IconsContainer from 'Utils/IconsContainer';
import React, { Component } from 'react';

/**
 * @typedef {object} props
 * @property {import('Stores/alertsHolderStore').AlertState} item
 * @property {boolean} archive
 * @extends {Component<props>}
 */
export default class Alert extends Component {
    render() {
        let { type, text, closeAlertHandler, hideCloseButton, createdAt, buttons } = this.props.item;

        let buttonsElements = buttons
            .map((x, i) =>
                <button
                    key={x.key}
                    className={'transparent-button alert-button' + (i == 0 ? '' : ' secondary-alert-button') + (this.props.archive ? ' disabled' : '')}
                    onClick={() => x.callback()}>
                    {x.title}
                </button>
            )
            .reverse();

        return (
            <div className={'alert' + (this.props.archive ? ' archived' : '')}>
                <div className={`colored-with-icon ${type}`}>
                    <div className='alert-icon'>
                        {IconsContainer.Get(`a-${type}`)}
                    </div>
                </div>
                <div className='text-with-close-button'>
                    <div className='alert-achived-date'>
                        {Helper.ToUserFrendlyTimeAndDateString(createdAt)}
                    </div>
                    <div className='alert-text'>
                        {text}
                    </div>
                    <div className='alert-buttons'>
                        {buttonsElements}
                        {
                            this.props.archive || !hideCloseButton ?
                                <button
                                    className='transparent-button alert-button'
                                    onClick={() => closeAlertHandler()}>
                                    Закрыть
                                </button>
                                : ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}